<template>
  <div class="notice-config-container flex-valign">
    <!-- 表格区域 -->
    <div class="table-container">
      <div class="main">
        <!--        <div style="width: 45%">-->
        <!--          <div-->
        <!--            class="title"-->
        <!--            :style="{-->
        <!--              padding: checkedKeysLeftList.length ? '10px 10px 30px' : '10px',-->
        <!--            }"-->
        <!--          >-->
        <!--          专项应急组-->
        <!--            <div-->
        <!--              class="checkTitle"-->
        <!--              :title="-->
        <!--                checkedKeysLeftList-->
        <!--                  .map((el) => {-->
        <!--                    return el.name;-->
        <!--                  })-->
        <!--                  .join(' | ')-->
        <!--              "-->
        <!--            >-->
        <!--              已选：-->
        <!--              {{-->
        <!--                checkedKeysLeftList-->
        <!--                  .map((el) => {-->
        <!--                    return el.name;-->
        <!--                  })-->
        <!--                  .join(" | ")-->
        <!--              }}-->
        <!--            </div>-->
        <!--          </div>-->
        <!--          <div class="dialog-tree__scroller-area" :key="key">-->
        <!--            <template v-if="treeDataLeft && treeDataLeft.length">-->
        <!--              <el-scrollbar class="dialog-tree__scroller">-->
        <!--                <el-tree-->
        <!--                  class="dialog-tree__tree"-->
        <!--                  ref="dialogTreeLeft"-->
        <!--                  :data="treeDataLeft"-->
        <!--                  accordion-->
        <!--                  :current-node-key="currentNodeId"-->
        <!--                  @node-click="handleNodeClick"-->
        <!--                  @check="handleNodeClick"-->
        <!--                  :props="treeProps"-->
        <!--                  :default-checked-keys="checkedKeysLeft"-->
        <!--                  :check-on-click-node="checkOnClickNode"-->
        <!--                  :highlight-current="highlightCurrent"-->
        <!--                  :default-expand-all="expandAll"-->
        <!--                  :show-checkbox="showCheckbox"-->
        <!--                  :node-key="nodeKey"-->
        <!--                  :expand-on-click-node="false"-->
        <!--                >-->
        <!--                  <span-->
        <!--                    class="custom-tree-node"-->
        <!--                    style="width: 100%"-->
        <!--                    slot-scope="{ node, data }"-->
        <!--                  >-->
        <!--                    <i-->
        <!--                      v-show="data.nodeType === 'area'"-->
        <!--                      :class="[areaIcon(data), 'area-node-icon']"-->
        <!--                    ></i>-->
        <!--                    <i-->
        <!--                      v-show="data.nodeType === 'device'"-->
        <!--                      class="iconfont-lunan icon-lunan-shexiangtou"-->
        <!--                    ></i>-->
        <!--                    <span-->
        <!--                      :title="node.label"-->
        <!--                      class="node-title"-->
        <!--                      style="-->
        <!--                        display: inline-block;-->
        <!--                        width: 80%;-->
        <!--                        overflow: hidden;-->
        <!--                        text-overflow: ellipsis;-->
        <!--                        white-space: nowrap;-->
        <!--                      "-->
        <!--                      >{{ node.label }}</span-->
        <!--                    >-->
        <!--                  </span>-->
        <!--                </el-tree>-->
        <!--              </el-scrollbar>-->
        <!--            </template>-->
        <!--            <div-->
        <!--              class="no-data-text"-->
        <!--              style="text-align: center; margin: 10px 0"-->
        <!--              v-else-->
        <!--            >-->
        <!--              <div>暂无数据</div>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--        </div>-->
        <div style="width: 45%">
          <div class="title">综合应急组</div>
          <div class="dialog-tree__scroller-area" :key="key">
            <template v-if="treeDataRight && treeDataRight.length">
              <el-scrollbar class="dialog-tree__scroller">
                <el-tree class="dialog-tree__tree" ref="dialogTreeRight" :data="treeDataRight" accordion
                  :current-node-key="currentNodeId" @node-click="handleNodeClick" @check="handleNodeClick"
                  :props="treeProps" :default-checked-keys="checkedKeysLeft" :check-on-click-node="checkOnClickNode"
                  :highlight-current="highlightCurrent" :default-expand-all="expandAll" :show-checkbox="showCheckbox"
                  :node-key="nodeKey" :expand-on-click-node="false">
                  <span class="custom-tree-node" style="width: 100%" slot-scope="{ node, data }">
                    <i v-show="data.nodeType === 'area'" :class="[areaIcon(data), 'area-node-icon']"></i>
                    <i v-show="data.nodeType === 'device'" class="iconfont-lunan icon-lunan-shexiangtou"></i>
                    <span :title="node.label" class="node-title" style="
                        display: inline-block;
                        width: 80%;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                      ">{{ node.label }}</span>
                  </span>
                </el-tree>
              </el-scrollbar>
            </template>
            <div class="no-data-text" style="text-align: center; margin: 10px 0" v-else>
              <div>暂无数据</div>
            </div>
          </div>
        </div>
      </div>
      <ioc-table style="margin-top: 116px" v-if="showTable" ref="crud" v-loading="tableLoading"
        element-loading-text="数据加载中..." element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)" :data="tableData" :option="tableOption" :page="page"
        @size-change="changeSize" @current-change="currentChange">
      </ioc-table>
    </div>
  </div>
</template>
<script>
import { Cache } from "$utils";
import { api } from "../api";
import tableOption from "../const/noticeTable";
import mixinFlv from "@src/components/common/media-player/mixinFlv";
export default {
  mixins: [mixinFlv],
  name: "notice-config",
  props: {
    reserveDetail: {
      type: Object,
      default: () => {
        return {};
      },
    },
    stepInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    handleProcessType: {
      type: String,
      default: () => {
        return "";
      },
    },
    showTable: {
      type: Boolean,
      default: () => {
        return true;
      },
    },
  },
  data() {
    return {
      checkedKeysLeft: [],
      checkedKeysRight: [],
      checkedKeysLeftList: [],
      // checkedKeysRightList: [],
      key: 0,
      showCheckbox: true,
      expandAll: false,
      treeData: [],
      handleClickData: [], //单选时的选中数据
      treeProps: {
        // 默认tree 参数
        children: "children",
        label: "name",
        isLeaf: "isLeaf",
      },
      currentNodeId: "",
      highlightCurrent: true, // 选中高亮。
      checkOnClickNode: true, // 默认点击选中。
      nodeKey: "id", //tree 唯一节点
      dialogVisible: false, //带弹窗tree
      searchText: "",
      playerLoading: false,
      tableOption: tableOption(true),
      options: [
        {
          value: "1",
          label: "车间应急组",
        },
        {
          value: "2",
          label: "综合应急组",
        },
      ],
      templateType: "1",
      radioOptions: [],
      fixedContent: "",
      groupName: "",
      selectKey: "1",
      tableData: [],
      // 车间应急组默认code
      workShopGroupCode: "",
      // 综合应急组默认code
      integratedGroupCode: "",
      // 分页属性设置
      page: {
        pageNum: 1,
        // total: 0,
        pageSize: 9999,
      },
      // 应急组table复选框选中的账户列表
      workshopInfoList: [],
      comprehensiveInfoList: [],
      // 固定模板list
      templateList: [],
      noticeTemplateCode: "",
      templateName: "",
      thirdCameraId: "",
      statusExpandType: false,
      treeDataLeft: [],
      treeDataRight: [],
      dialogTitle: "",
      customForm: {
        notifyContent: "",
        handleProcessCode: "",
      },
      processNames: "",
      handleProcessList: "",
      tableLoading: false,
    };
  },
  created() {
    this.getTemplate();
    this.checkedKeysLeft = this.reserveDetail.workShopGroupCodeList;
  },
  mounted() { },
  beforeDestroy() { },
  methods: {
    getTreeData() {
      Promise.all([this.getTree(1), this.getTree(2)]).then((res) => {
        this.$nextTick(() => {
          this.getTableData();
        });
      });
    },
    setData(type, data) {
      if (type == "left") {
        this.checkedKeysLeft = data;
      } else {
        this.checkedKeysRight = data;
      }
    },
    handleNodeClick(data, node) {
      this.getTableData();
      if (data.type == "workShopGroup") {
        this.checkedKeysLeftList = [...node.checkedNodes];
      } else {
        // this.checkedKeysRightList = [...node.checkedNodes];
      }
    },
    areaIcon(data) {
      const account = Cache.get("CACHE_USER_INFO");
      if (account.parkInfo.areaDevGroupCode === data.id) {
        return this.$config.fontFamily + " ioc-Build";
      } else {
        return "el-icon-office-building";
      }
    },
    // 因页面有3个弹框树 所以封装成一个组件
    getTree(type) {
      // type 1车间应急组 2.综合应急组 3.摄像机设备树
      const self = this;
      let url = "";
      let params = {};
      if (type == "1") {
        url = api.reserveProcess.queryWorkShopGroup;
      } else if (type == "2") {
        url = api.reserveProcess.queryIntegratedGroup;
      }
      return this.$fetch(url, params).then((response) => {
        if (response.success) {
          if (type == "1") {
            this.checkedKeysLeftList = [];
            const result = self.menusWorkshopDataPro(response.returnObj);
            self.treeDataLeft = Object.freeze(result);
          } else if (type == "2") {
            const result = self.menusComDataPro(response.returnObj);
            self.treeDataRight = Object.freeze(result);
            self.$nextTick(() => {
              self.$refs.dialogTreeRight.setCheckedNodes(result); //综合应急默认全选
            });
          }
        }
      });
    },
    //递归车间应急组树结构
    menusWorkshopDataPro(data) {
      const self = this;
      const result = [];
      if (data !== null) {
        data.forEach(function (item) {
          const entity = {};
          entity.type = "workShopGroup";
          entity.id = item.workShopGroupCode;
          entity.name = item.workShopGroupName;
          entity.workShopDirectorPhone = item.workShopDirectorPhone;
          entity.workShopDirector = item.workShopDirector;
          entity.workShopLeader = item.workShopLeader;
          entity.workShopLeaderPhone = item.workShopLeaderPhone;
          entity.parentCode = item.parentCode;
          entity.workShopTelephone = item.workShopTelephone;
          entity.isLeaf = !item.hasLeaf || !item.workShopGroupChildren;
          if (self.checkedKeysLeft.indexOf(item.workShopGroupCode) != -1) {
            self.checkedKeysLeftList.push(entity);
          }
          if (item.workShopGroupChildren) {
            entity.children = self.menusWorkshopDataPro(
              item.workShopGroupChildren
            );
          }
          result.push(entity);
        });
        return result;
      }
    },
    //递归综合应急组树结构
    menusComDataPro(data) {
      const self = this;
      const result = [];
      if (data !== null) {
        data.forEach(function (item) {
          const entity = {};
          entity.type = "integratedGroup";
          entity.id = item.integratedGroupCode;
          entity.name = item.integratedGroupName;
          entity.parentCode = item.parentCode;
          entity.isLeaf = !item.hasLeaf || !item.integratedGroupChildren;
          if (item.integratedGroupChildren) {
            entity.children = self.menusComDataPro(
              item.integratedGroupChildren
            );
          }
          result.push(entity);
        });
        return result;
      }
    },
    getTable(data) {
      console.log(this.$refs.dialogTreeLeft);
      this.$refs.dialogTreeLeft.setCheckedNodes(data);
      // console.log(
      //   this.$refs.dialogTreeRight.getCheckedNodes().map((el) => {
      //     return el.id;
      //   })
      // );
    },
    // 获取表格data
    getTableData(data) {
      // console.log(this.$refs.dialogTreeLeft.getCheckedNodes());
      // console.log(this.$refs.dialogTreeRight.getCheckedNodes());
      let params = {};
      if (data) {
        params = {
          workShopGroupCodeList: data.leftData,
          pageNum: this.page.pageNum,
          pageSize: this.page.pageSize,
          integratedGroupCodeList: data.rightData,
        };
      } else {
        params = {
          workShopGroupCodeList: this.$refs.dialogTreeLeft
            ? this.$refs.dialogTreeLeft.getCheckedNodes().map((el) => {
              return el.id;
            })
            : [],
          pageNum: this.page.pageNum,
          pageSize: this.page.pageSize,
          integratedGroupCodeList: this.$refs.dialogTreeRight
            .getCheckedNodes()
            .map((el) => {
              return el.id;
            }),
        };
      }
      this.tableLoading = true;
      this.$fetch(api.reserveProcess.queryPersonOrAccountByPage, params).then(
        (response) => {
          this.tableLoading = false;
          if (!response.success) {
            this.$message.error(response.msgContent);
            return;
          }
          this.tableData = response.returnObj.list
            ? Object.freeze([...response.returnObj.list])
            : [];
        }
      );
    },
    // 修改每页数据数量
    changeSize(val) {
      this.page.pageNum = 1;
      this.page.pageSize = val;
      this.getTableData();
    },
    // 点击上一页下一页按钮
    currentChange(val) {
      this.page.pageNum = val;
      this.getTableData();
    },
    // 获取固定模板
    getTemplate() {
      let params = {
        serviceType: 2, //1：罚单通知，2：预案通知，3：预约通知,  4：自定义工单通知
        templateType: 3, //短信通知3，信息通知5
      };
      this.$fetch(api.reserveProcess.queryNoticeTemplateList, params).then(
        (response) => {
          if (!response.success) {
            this.$message.error(response.msgContent);
            return;
          }
          this.templateList = response.returnObj;
        }
      );
    },
    saveData() {
      if (this.tableData.length == 0) {
        this.$message.warning("请选择人员后下发通知");
        this.$emit("sendFinish");
        return;
      }
      let params = {
        accountInfoList: this.tableData.map((el) => {
          return {
            name: el.name,
            personOrAccountCode:
              el.personOrAccountType == 2 ? el.workNo : el.personOrAccountCode,
            personOrAccountType: el.personOrAccountType,
            phone: el.phone,
          };
        }),
        emergencyRecordCode: this.stepInfo.emergencyRecordCode,
        noticeTemplateCode: this.templateList[0].noticeTemplateCode,
        integratedGroupCodeList: this.$refs.dialogTreeRight
          .getCheckedNodes()
          .map((el) => {
            return el.id;
          }), //综合应急组
        // workShopGroupCodeList: this.$refs.dialogTreeLeft
        //   .getCheckedNodes()
        //   .map((el) => {
        //     return el.id;
        //   }), //车间应急组
      };
      this.$fetch(api.reserveProcess.addEmergencySms, params).then(
        (response) => {
          if (response.success) {
            this.$message.success("发送成功");
          } else {
            this.$message.error(response.msgContent);
          }
          this.$emit("sendFinish");
        }
      );
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";

:deep .el-tree-node__content {
  height: 35px;
}


.notice-config-container {
  .el-tree-node__children {
    max-height: 280px;
    overflow: auto;
  }

  .title {
    // border-left: 4px solid #407aee;
    @include set_theme_color(background-color, dialog-main-bg-color);
    padding: 10px;
    font-size: 15px;
    height: 56px;
    color: #407aee;
  }

  .checkTitle {
    @include set_theme_color(color, font-inactive-color);
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: none;
    white-space: nowrap;
    width: 38%;
    position: absolute;
    margin: 5px 0;
    font-size: 13px;
  }

  .table-container {
    height: 470px;

    .main {
      display: flex;
      justify-content: space-between;
      padding-bottom: 20px;
      padding-top: 10px;
      position: absolute;
      width: calc(100% - 24px);
      z-index: 2;
    }
  }

  .tree-content {
    width: fit-content;
    min-width: 100%;

    .el-tree-node__label {
      display: inline-block;
      max-width: 80%;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }

    .el-tree-node__content {
      height: 40px;
      line-height: 40px;
      margin: 5px 0;

      &:hover {
        background: rgb(45, 73, 118);
      }

      .custom-tree-node {
        width: 100%;
        height: 40px;
        line-height: 40px;
        display: flex;

        .tree-label {
          width: 150px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .area-operator {
          display: inline-block;
          margin-left: 10px;
        }
      }

      &:before {
        margin-top: -26px !important;
      }
    }
  }

  .content-box {
    .template-choose {
      .el-radio-group {
        margin-right: 10px;
      }
    }

    .fixTemplate-content {
      .select-choose {
        width: 260px;
      }
    }

    .custom-box {
      width: 100%;

      .top-content {
        width: 100%;
      }

      .bottom-content {
        .video-area {
          width: 100%;

          .video-content {
            width: 50%;
            height: 320px;

            .player-box {
              width: 100%;
              height: calc(100% - 100px);
              background: #3a3a3a url("/images/theme/newDark/default.png") center no-repeat;
              border: rgba(#000, 0.5) solid 2px;
              position: relative;

              &__loading {
                position: absolute;
                left: 0;
                top: 0;
                z-index: 1;
                width: 100%;
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                background-color: rgba($color: #000, $alpha: 0.4);
              }
            }
          }
        }

        .process-box {
          position: relative;

          .drop-down {
            .title-choose {
              .process-span {
                @include set_theme_color(color, font-inactive-color);
                line-height: 36px;
                font-size: 20px;
                font-weight: normal;
              }
            }

            .select-arrow,
            .icon-transform {
              margin-left: 5px;
              font-size: 18px;
              color: #9aa6c1;
            }

            .select-arrow {
              display: inline-block;
              transition: 0.3s;
              -moz-transition: 0.3s;
              /* Firefox 4 */
              -webkit-transition: 0.3s;
              /* Safari 和 Chrome */
              -o-transition: 0.3s;
              cursor: pointer;
            }

            .icon-transform {
              transform: rotate(180deg);
            }
          }

          .type-select {
            @include set_theme_color(background-color, top-menu-bg-color);
            position: absolute;
            top: 40px;
            right: 0px;
            width: 350px;
            overflow: hidden;
            transition: all 0.2s;
            z-index: 101;
            height: calc(100% - 140px);

            .scroll-area {
              height: 185px;
            }

            .content-container {
              height: 100%;

              .processList {
                cursor: pointer;
                line-height: 32px;

                &:hover,
                &.active {
                  background-color: #3f619b;
                }

                .processList-title {
                  display: inline-block;
                  flex: 1;
                }

                .choose-tag {
                  width: 30px;
                  text-align: center;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
